import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  EPageLayout,
  PageLayoutComponent,
  IconComponent
} from "@zaeper/angular-dashboard-view-lib";
import { ZTemplateDirective } from "@zaeper/angular-core-lib";
import { ButtonModule } from "primeng/button";
import { TableModule } from "primeng/table";
import { TagModule } from "primeng/tag";
import { CardModule } from "primeng/card";
import { TooltipModule } from "primeng/tooltip";
import { MenuItem } from "primeng/api";
import { IInvoice } from "../../models/i-invoice";
import { IDeveloperBillingRestClient } from "../../rest-clients/billing/i-developer-billing-rest.client";
import { developerBillingRestClientInjectionToken } from "../../rest-clients/billing/developer-billing-rest-client-injection-token";

@Component({
  selector: "app-payment-overview-page",
  templateUrl: "./payment-overview-page.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    TableModule,
    TagModule,
    CardModule,
    TooltipModule,
    ZTemplateDirective,
    PageLayoutComponent,
    IconComponent
  ]
})
export class PaymentOverviewPageComponent implements OnInit {
  public readonly ePageLayout: typeof EPageLayout = EPageLayout;

  public readonly navigation: MenuItem[] = [
    {
      icon: "pi pi-home",
      routerLink: "/de/"
    },
    {
      label: "Rechnungsübersicht",
      routerLink: "/de/payment-overview"
    }
  ];

  public invoices: IInvoice[] = [];
  public isLoading: boolean = true;

  constructor(
    @Inject(developerBillingRestClientInjectionToken) private readonly _billingRestClient: IDeveloperBillingRestClient,
    private readonly _cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this._loadInvoices();
  }

  public getStatusSeverity(status: string): "success" | "warn" | "danger" {
    switch (status) {
      case "paid":
        return "success";
      case "open":
        return "warn";
      case "uncollectible":
        return "danger";
      default:
        return "warn";
    }
  }

  public getStatusLabel(status: string): string {
    switch (status) {
      case "paid":
        return "Bezahlt";
      case "open":
        return "Offen";
      case "draft":
        return "Entwurf";
      case "void":
        return "Storniert";
      case "uncollectible":
        return "Nicht einbringlich";
      default:
        return status;
    }
  }

  public formatDate(epochSeconds: number): string {
    return new Date(epochSeconds * 1000).toLocaleDateString("de-DE");
  }

  public formatCurrency(amountCents: number, currency: string): string {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: currency.toUpperCase()
    }).format(amountCents / 100);
  }

  public downloadInvoice(invoice: IInvoice): void {
    if (invoice.invoicePdfUrl) {
      window.open(invoice.invoicePdfUrl, "_blank");
    }
  }

  public viewInvoice(invoice: IInvoice): void {
    if (invoice.hostedInvoiceUrl) {
      window.open(invoice.hostedInvoiceUrl, "_blank");
    }
  }

  private _loadInvoices(): void {
    this.isLoading = true;
    this._cdr.markForCheck();

    this._billingRestClient.listInvoices().then((invoices: IInvoice[]) => {
      this.invoices = invoices;
      this.isLoading = false;
      this._cdr.markForCheck();
    }).catch(() => {
      this.invoices = [];
      this.isLoading = false;
      this._cdr.markForCheck();
    });
  }
}
